export const comics = [
  {
    id: 1,
    slug: 'secret-romance',
    title: '秘密恋爱',
    author: '金智秀',
    category: 'romance',
    status: '连载中',
    rating: 9.2,
    views: 1280000,
    chapters: 86,
    updatedAt: '2026-07-07',
    description: '在一场意外的邂逅后，两个来自不同世界的人开始了秘密的恋爱关系。她是他公司的实习生，他是她的直属上司。两人约定保守秘密，却在日常相处中逐渐深陷。当爱情与职场碰撞，他们该如何抉择？这是一个关于成长、责任与勇气的甜蜜故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20cover%20art%2C%20young%20couple%20in%20modern%20office%20setting%2C%20soft%20warm%20lighting%2C%20clean%20simple%20background%20with%20pastel%20tones%2C%20professional%20illustration%20style%2C%20delicate%20linework%2C%20emotional%20expressions%2C%20webtoon%20cover%20aesthetic&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    tags: ['恋爱', '职场', '甜蜜'],
  },
  {
    id: 2,
    slug: 'dragon-slayer',
    title: '龙骑士传说',
    author: '李恩在',
    category: 'fantasy',
    status: '连载中',
    rating: 9.5,
    views: 2560000,
    chapters: 142,
    updatedAt: '2026-07-07',
    description: '在魔龙横行的异世界中，平凡少年艾伦意外获得了上古龙骑士的传承。从此他踏上了屠龙之路，结识了精灵、矮人和人类伙伴，组建了最强的冒险队伍。然而，随着冒险的深入，他发现魔龙背后隐藏着一个惊天阴谋。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20knight%20with%20sword%20facing%20dragon%2C%20epic%20medieval%20fantasy%20setting%2C%20dramatic%20lighting%20with%20warm%20golden%20tones%2C%20detailed%20armor%20design%2C%20clean%20simple%20background%2C%20professional%20illustration%2C%20webtoon%20cover%20aesthetic&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    tags: ['奇幻', '冒险', '战斗'],
  },
  {
    id: 3,
    slug: 'shadow-agent',
    title: '暗影特工',
    author: '朴宰贤',
    category: 'action',
    status: '已完结',
    rating: 9.0,
    views: 1890000,
    chapters: 120,
    updatedAt: '2026-07-06',
    description: '前特种部队成员金泰浩隐退后过着平凡生活，却因为一起神秘事件再次被卷入谍战漩涡。他必须运用自己的战斗技巧和智慧，在暗影中揭露跨国犯罪组织的阴谋。紧张的追逐战、激烈的格斗场面，每一页都让人血脉偾张。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20secret%20agent%20in%20black%20suit%20holding%20gun%2C%20noir%20cityscape%20background%2C%20dramatic%20shadow%20lighting%2C%20cool%20tone%20with%20warm%20accents%2C%20clean%20simple%20composition%2C%20professional%20illustration%2C%20webtoon%20cover%20aesthetic&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    tags: ['动作', '谍战', '悬疑'],
  },
  {
    id: 4,
    slug: 'midnight-mystery',
    title: '午夜谜案',
    author: '郑秀晶',
    category: 'suspense',
    status: '连载中',
    rating: 9.3,
    views: 980000,
    chapters: 56,
    updatedAt: '2026-07-05',
    description: '连环杀人案打破了小城的宁静。侦探林秀雅接手案件后发现，每一起案件都指向十年前的一桩悬案。随着调查深入，她发现自己也成了凶手的下一个目标。时间在流逝，真相在逼近，这个午夜谜案远比她想象的更加复杂。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20cover%20art%2C%20female%20detective%20in%20dark%20alley%2C%20noir%20atmosphere%2C%20moonlight%20and%20street%20lamp%20lighting%2C%20moody%20blue%20and%20warm%20contrast%20tones%2C%20clean%20simple%20background%2C%20professional%20illustration%2C%20webtoon%20cover%20aesthetic&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    tags: ['悬疑', '推理', '犯罪'],
  },
  {
    id: 5,
    slug: 'daily-laugh',
    title: '爆笑日常',
    author: '韩智浩',
    category: 'comedy',
    status: '连载中',
    rating: 8.9,
    views: 3200000,
    chapters: 205,
    updatedAt: '2026-07-07',
    description: '四个性格迥异的大学生合租的故事。有社交恐惧症的程序员、自来熟的营销达人、强迫症的设计师和永远睡不醒的自由职业者。他们的日常充满各种意想不到的乌龙事件和爆笑瞬间，每一话都能让你捧腹大笑。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%2C%20four%20friends%20laughing%20in%20college%20dorm%2C%20bright%20colorful%20style%2C%20warm%20cheerful%20lighting%2C%20clean%20simple%20background%20with%20pastel%20colors%2C%20fun%20expressions%2C%20professional%20illustration%2C%20webtoon%20cover%20aesthetic&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    tags: ['搞笑', '日常', '校园'],
  },
  {
    id: 6,
    slug: 'tears-of-autumn',
    title: '秋日泪痕',
    author: '崔美英',
    category: 'drama',
    status: '已完结',
    rating: 9.6,
    views: 1780000,
    chapters: 95,
    updatedAt: '2026-07-04',
    description: '一个关于家庭、爱与失去的故事。主人公李素妍在秋天失去了唯一的亲人后，开始重新审视自己的人生。在独自前行的路上，她遇见了同样受伤的韩智勋，两个灵魂在秋日的余晖中互相取暖。这是一个温暖治愈又催人泪下的故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20art%2C%20woman%20standing%20under%20autumn%20maple%20tree%2C%20melancholic%20warm%20tone%2C%20soft%20golden%20hour%20lighting%2C%20emotional%20atmosphere%2C%20clean%20simple%20composition%2C%20delicate%20watercolor%20style%2C%20professional%20illustration%2C%20webtoon%20cover%20aesthetic&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    tags: ['剧情', '治愈', '人生'],
  },
  {
    id: 7,
    slug: 'night-walker',
    title: '夜行者',
    author: '吴世勋',
    category: 'horror',
    status: '连载中',
    rating: 8.8,
    views: 750000,
    chapters: 48,
    updatedAt: '2026-07-06',
    description: '深夜的医院走廊传来诡异的脚步声。实习医生张民浩在值夜班时，频繁遭遇无法解释的超自然现象。当他开始深入调查医院的历史时，几十年前的医疗事故真相慢慢浮出水面。而那个游荡在走廊的幽灵，似乎和他有着不为人知的联系。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20cover%20art%2C%20dark%20hospital%20corridor%20with%20shadow%20figure%2C%20eerie%20atmosphere%2C%20cold%20blue%20and%20dark%20tone%2C%20flickering%20light%20effect%2C%20clean%20simple%20composition%2C%20professional%20illustration%2C%20webtoon%20cover%20aesthetic&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    tags: ['惊悚', '恐怖', '超自然'],
  },
  {
    id: 8,
    slug: 'first-love-again',
    title: '重返初恋',
    author: '姜瑞妍',
    category: 'romance',
    status: '连载中',
    rating: 9.1,
    views: 2100000,
    chapters: 72,
    updatedAt: '2026-07-07',
    description: '三十岁的白领尹秀敏意外回到了高中时代。带着成年人的记忆，她遇见了当年暗恋的学长朴正宇。这一次，她决定不再懦弱，勇敢追逐自己的初恋。然而改变过去也意味着改变未来，每一个选择都牵动着命运的齿轮。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20high%20school%20couple%20under%20cherry%20blossom%20tree%2C%20spring%20atmosphere%2C%20soft%20pink%20and%20warm%20lighting%2C%20dreamy%20nostalgic%20feel%2C%20clean%20simple%20background%2C%20professional%20illustration%2C%20webtoon%20cover%20aesthetic&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    tags: ['恋爱', '穿越', '校园'],
  },
  {
    id: 9,
    slug: 'magic-academy',
    title: '魔法学院',
    author: '沈恩智',
    category: 'fantasy',
    status: '连载中',
    rating: 9.4,
    views: 1630000,
    chapters: 98,
    updatedAt: '2026-07-05',
    description: '普通高中生林智敏在十八岁生日那天收到了魔法学院的录取通知书。在这个隐藏在现实世界中的魔法学院里，她不仅学习各种魔法，还揭开了自己身世的秘密。与黑暗势力的斗争，友情与爱情的考验，都在等待着这个年轻的魔法师。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20magic%20academy%20student%20casting%20spell%2C%20magical%20glowing%20effects%2C%20mystical%20atmosphere%2C%20warm%20golden%20and%20mystic%20purple%20tones%2C%20clean%20simple%20background%2C%20professional%20illustration%2C%20webtoon%20cover%20aesthetic&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    tags: ['奇幻', '校园', '成长'],
  },
  {
    id: 10,
    slug: 'street-fighter',
    title: '街头斗士',
    author: '赵敏奎',
    category: 'action',
    status: '连载中',
    rating: 8.7,
    views: 1450000,
    chapters: 64,
    updatedAt: '2026-07-06',
    description: '地下格斗比赛的冠军姜武赫为了给妹妹治病，不得不重返擂台。每一场战斗都是生死较量，每一个对手都不可小觑。在这个血与汗的世界里，他用拳头开辟出属于自己的道路。热血格斗，拳拳到肉的视觉冲击。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20street%20fighter%20in%20boxing%20stance%2C%20urban%20underground%20arena%2C%20intense%20dramatic%20lighting%2C%20warm%20amber%20and%20dark%20contrast%2C%20dynamic%20pose%2C%20clean%20simple%20background%2C%20professional%20illustration%2C%20webtoon%20cover%20aesthetic&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    tags: ['动作', '格斗', '热血'],
  },
  {
    id: 11,
    slug: 'love-recipe',
    title: '恋爱食谱',
    author: '朴秀珍',
    category: 'romance',
    status: '连载中',
    rating: 9.0,
    views: 870000,
    chapters: 53,
    updatedAt: '2026-07-07',
    description: '米其林餐厅的冷面主厨和热情开朗的美食博主因为一档美食节目相遇。两个性格截然不同的人，用料理传递心意，用美食谱写恋曲。每一道菜品都承载着一段故事，每一个眼神都藏着说不出的温柔。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20chef%20and%20food%20blogger%20in%20kitchen%2C%20warm%20restaurant%20lighting%2C%20cozy%20atmosphere%2C%20soft%20golden%20tones%2C%20delicious%20food%20on%20table%2C%20clean%20simple%20background%2C%20professional%20illustration%2C%20webtoon%20cover%20aesthetic&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    tags: ['恋爱', '美食', '职场'],
  },
  {
    id: 12,
    slug: 'ghost-detective',
    title: '幽灵侦探',
    author: '金在勋',
    category: 'suspense',
    status: '已完结',
    rating: 9.2,
    views: 1120000,
    chapters: 80,
    updatedAt: '2026-07-03',
    description: '拥有看见鬼魂能力的私家侦探李贤宇，利用自己的特殊能力侦破各种疑难案件。每一集都是一个独立的推理故事，同时主线也在悄悄推进。鬼魂的证词、蛛丝马迹的线索、意想不到的反转，带你走进一个个精彩纷呈的推理世界。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20cover%20art%2C%20detective%20with%20ghostly%20figure%20beside%20him%2C%20noir%20city%20at%20night%2C%20mysterious%20atmosphere%2C%20cool%20blue%20and%20warm%20amber%20contrast%2C%20clean%20simple%20composition%2C%20professional%20illustration%2C%20webtoon%20cover%20aesthetic&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    tags: ['悬疑', '推理', '超自然'],
  },
];

export const featuredComicIds = [2, 4, 6, 8, 9, 1];
export const popularComicIds = [5, 3, 1, 6, 2, 8, 4, 7];
export const latestComicIds = [1, 5, 11, 3, 10, 7, 2, 12];

export const getComicById = (id: number) => comics.find((c) => c.id === id);
export const getComicBySlug = (slug: string) => comics.find((c) => c.slug === slug);
export const getComicsByCategory = (category: string) =>
  category === 'all' ? comics : comics.filter((c) => c.category === category);
export const getRelatedComics = (comicId: number, limit: number = 4) => {
  const comic = getComicById(comicId);
  if (!comic) return [];
  return comics.filter((c) => c.category === comic.category && c.id !== comicId).slice(0, limit);
};